import { useAemConfig } from '@as-react/common-components';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../constants/i18nConstants';
import { getProductDiscount } from '../util/ProductUtil';
import { showPriceDiscount } from '@as-react/common-utils';
export const usePriceDiscountTag = (priceInformation, dynamicSavingsInformation, enablePriceReference) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const { currency } = useAemConfig();
    const productDiscount = getProductDiscount(dynamicSavingsInformation === null || dynamicSavingsInformation === void 0 ? void 0 : dynamicSavingsInformation.productDiscountAmount, dynamicSavingsInformation === null || dynamicSavingsInformation === void 0 ? void 0 : dynamicSavingsInformation.productDiscountPercentage, currency);
    if (!(priceInformation === null || priceInformation === void 0 ? void 0 : priceInformation.hasDiscount) || !productDiscount) {
        return undefined;
    }
    return showPriceDiscount(priceInformation.prices, Boolean(enablePriceReference))
        ? {
            text: `${t(`${I18N_NAMESPACES.product}:pdp.dynamic.savings`)} ${productDiscount}`,
        }
        : undefined;
};
